var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentralAfricanRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.002C24.8366 32.002 32 24.8385 32 16.002C32 7.1654 24.8366 0.00195312 16 0.00195312C7.16344 0.00195312 0 7.1654 0 16.002C0 24.8385 7.16344 32.002 16 32.002Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0543 8.34983C27.9868 4.56052 24.4316 1.69996 20.1737 0.552338L19.478 8.34983H30.0543Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94543 8.34983H12.5217L11.8261 0.552338C7.56812 1.69996 4.013 4.56058 1.94543 8.34983V8.34983Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4779 16.002V23.6541H30.0541C31.2944 21.381 31.9996 18.7738 31.9996 16.002H19.4779Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 16.002H0C0 18.7738 0.705188 21.381 1.94544 23.6541H12.5217V16.002H12.5218Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94543 23.6541C4.013 27.4434 7.56812 30.304 11.8261 31.4516L12.5217 24.6323L1.94543 23.6541Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1737 31.4516C24.4316 30.304 27.9868 27.4434 30.0543 23.6541L19.478 24.6321L20.1737 31.4516Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4779 24.6321L30.0542 23.6541H19.4779V24.6321Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 23.6541H1.94543L12.5217 24.6321V23.6541Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0.00195313C14.556 0.00195313 13.1572 0.194453 11.8263 0.553141V31.4508C13.1572 31.8095 14.556 32.002 16.0002 32.002C17.4444 32.002 18.8433 31.8095 20.1742 31.4508V0.553141C18.8433 0.194453 17.4444 0.00195312 16.0002 0.00195312V0.00195313Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60572 3.4801L9.03735 4.80866H10.4344L9.30428 5.62979L9.73597 6.95835L8.60572 6.13729L7.47553 6.95835L7.90735 5.62979L6.77722 4.80866H8.17416L8.60572 3.4801Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralAfricanRepublic);
export default __webpack_public_path__ + "static/media/central-african-republic.eb8e7fb3.svg";
export { ForwardRef as ReactComponent };